import { createRouter, type RouterHistory } from "@tanstack/react-router";
import { routeErrorOptions } from "./route-error-options";
import { routeTree } from "./routeTree.gen";

export function createAppRouter(history?: RouterHistory) {
  return createRouter({ routeTree, history, ...routeErrorOptions });
}

export const router = createAppRouter();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
